export const EXCMNOTE_CREATE_RESET = 'EXCMNOTE_CREATE_RESET'
export const EXCMNOTE_CREATE_SET_CREATED = 'EXCMNOTE_CREATE_SET_CREATED'
export const EXCMNOTE_CREATE_SET_ERROR = 'EXCMNOTE_CREATE_SET_ERROR'
export const EXCMNOTE_CREATE_SET_VIOLATIONS = 'EXCMNOTE_CREATE_SET_VIOLATIONS'
export const EXCMNOTE_CREATE_TOGGLE_LOADING = 'EXCMNOTE_CREATE_TOGGLE_LOADING'
